import { gql } from 'graphql-request';
import {
  MaterialBlocked,
  MaterialBrandID,
  MaterialBrandName,
  MaterialCategoryID,
  MaterialCategoryName,
  MaterialClientCurrentTeamNanoId,
  MaterialClientFullName,
  MaterialClientID,
  MaterialClientNanoId,
  MaterialFavorite,
  MaterialID,
  MaterialImageFile,
  MaterialImageID,
  MaterialImageName,
  MaterialImageSize,
  MaterialImageUUID,
  MaterialMaxFileCreatedAt,
  MaterialMaxFileFile,
  MaterialMaxFileID,
  MaterialMaxFileName,
  MaterialMaxFileSize,
  MaterialMaxFileUUID,
  MaterialName,
  MaterialNanoID,
  MaterialNda,
  MaterialSku,
  MaterialTeamID,
  MaterialTeamName,
  MaterialTeamNanoId,
  MaterialTeamUUID,
  MaterialUUID,
  MaterialProductID,
  MaterialLifestyleID
} from '../materialsTypes';

export interface FetchShowMaterialQueryResponseImage {
  id: MaterialImageID;
  uuid: MaterialImageUUID;
  file: MaterialImageFile;
  size: MaterialImageSize;
  name: MaterialImageName;
}

export interface FetchShowMaterialQueryResponseMaxFile {
  id: MaterialMaxFileID;
  uuid: MaterialMaxFileUUID;
  file: MaterialMaxFileFile;
  size: MaterialMaxFileSize;
  name: MaterialMaxFileName;
}

export interface FetchShowMaterialQueryResponse {
  id: MaterialID;
  nanoId: MaterialNanoID;
  uuid: MaterialUUID;
  name: MaterialName;
  sku: MaterialSku;
  nda: MaterialNda;
  image: FetchShowMaterialQueryResponseImage;
  images?: FetchShowMaterialQueryResponseImage[];
  maxFile: {
    createdAt: MaterialMaxFileCreatedAt;
  };
  maxFiles?: FetchShowMaterialQueryResponseMaxFile[];
  favorite: MaterialFavorite;
  blocked: MaterialBlocked;
  categories?: {
    id: MaterialCategoryID;
    localizedName: MaterialCategoryName;
  }[];
  brand?: {
    id: MaterialBrandID;
    localizedName: MaterialBrandName;
  };
  clients: {
    id: MaterialClientID;
    nanoId: MaterialClientNanoId;
    fullName: MaterialClientFullName;
    currentTeam: {
      nanoId: MaterialClientCurrentTeamNanoId;
    };
  }[];
  teams: {
    id: MaterialTeamID;
    nanoId: MaterialTeamNanoId;
    uuid: MaterialTeamUUID;
    name: MaterialTeamName;
  }[];
  products?: {
    id: MaterialProductID;
  }[];
  lifestyles?: {
    id: MaterialLifestyleID;
  }[];
}

export const FETCH_SHOW_MATERIAL_QUERY = gql`
  query ShowMaterial($uuid: ID!) {
    material(uuid: $uuid) {
      id
      nanoId
      uuid
      name
      sku
      nda
      favorite
      blocked
      categories {
        id
        localizedName
      }
      brand {
        id
        localizedName
      }
      image {
        id
        uuid
        size
        name
        file
      }
      images {
        id
        uuid
        file
        size
        name
      }
      maxFile {
        createdAt
      }
      maxFiles {
        id
        uuid
        file
        size
        name
      }
      clients {
        id
        nanoId
        fullName
        currentTeam {
          nanoId
        }
      }
      products {
        id
      }
      lifestyles {
        id
      }
    }
  }
`;
